<ng-container *transloco="let t">
  <ng-container *ngIf="(pictures || []).length > 0">
    <swiper
      class="swiper main-picture"
      [class.mobile]="(lessThan$ | async)?.sm"
      [class.desktop]="!(lessThan$ | async)?.sm"
      [loop]="true"
      [zoom]="true"
      [hashNavigation]="{
        watchState: true
      }"
      [spaceBetween]="16"
      [navigation]="false"
      [pagination]="{
        clickable: true
      }"
      [thumbs]="{ swiper: thumbsSwiper }">
      <ng-container *ngFor="let picture of pictures || []; trackBy: trackByPicture">
        <ng-template swiperSlide>
          <img [src]="picture.src" alt="picture" />
        </ng-template>
      </ng-container>
    </swiper>
  </ng-container>

  <ng-container *ngIf="(pictures || []).length > 1 && (lessThan$ | async)?.sm === false">
    <span class="fixed-space-16" aria-hidden="true"></span>
    <swiper
      class="swiper preview-track"
      [class.wide-mode]="wideMode"
      [class.mobile]="(lessThan$ | async)?.sm"
      [loop]="false"
      [spaceBetween]="8"
      [slidesPerView]="(pictures || []).length"
      [freeMode]="false"
      [watchSlidesProgress]="false"
      (swiper)="thumbsSwiper = $event">
      <ng-container *ngFor="let picture of pictures || []; trackBy: trackByPicture">
        <ng-template swiperSlide>
          <img [src]="picture.src" alt="picture" />
        </ng-template>
      </ng-container>
    </swiper>
  </ng-container>

  <ng-container *ngIf="!((pictures || []).length > 0)">
    <app-spinner class="loading-spinner" [contrast]="true"></app-spinner>
  </ng-container>
</ng-container>
